import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from 'react-router-dom';
import img_404 from '../../static/images/img_404.png';
import { i18n } from '../../language';
import rou from '../../router';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '26.4vh',
    display: 'flex',
    justifyContent: 'center',
  },
  img: {
    width: '34.625rem',
  },
  title: {
    height: '4.063rem',
    fontFamily: 'NotoSans-Bold',
    fontSize: '3rem',
    letterSpacing: '-0.09px',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    margin: '2.187rem 0 0.625rem',
    display: 'flex',
    justifyContent: 'center',
  },
  context: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    width: '26.313rem',
    margin: '0 auto',
    textAlign: 'center',
  },
  button: {
    margin: '1.875rem auto 0',
    width: '13.875rem',
    height: '3rem',
    backgroundColor: '#4c93ff',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
    textDecoration: 'none',
  },
}));

export default function Page404() {
  const classes = useStyles();
  const history = useHistory();

  // 自动回到home page
  useEffect(() => {
    history.push(rou.homeRou.path);
  }, []);

  return (
    <div className={classes.root}>
      <div>
        <img className={classes.img} src={img_404} alt="" />
        <div className={classes.title}>{i18n.t('Page404_title')}</div>
        <div className={classes.context}>{i18n.t('Page404_subtitle')}</div>
        <Link className={classes.button} to={rou.homeRou.path}>
          {i18n.t('Page404_button')}
        </Link>
      </div>
    </div>
  );
}
